import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { LambdaControlState } from "./lambdaControlTypes";
import { GridSortModel, GridFilterModel } from "@mui/x-data-grid-premium";
import dayjs from "dayjs";

const initialState: LambdaControlState = {
  startDate: dayjs().add(-1, "day").toISOString(),
  endDate: new Date().toISOString(),
  sortModel: [{ field: "end", sort: "desc" }],
  filterModel: { items: [] },
};

const lambdaControlSlice = createSlice({
  name: "lambdaControl",
  initialState,
  reducers: {
    setStart: (state, action: PayloadAction<string>) => {
      state.startDate = action.payload;
    },
    setEnd: (state, action: PayloadAction<string>) => {
      state.endDate = action.payload;
    },
    setSortModel: (state, action: PayloadAction<GridSortModel>) => {
      state.sortModel = action.payload;
    },
    setFilterModel: (state, action: PayloadAction<GridFilterModel>) => {
      state.filterModel = action.payload;
    },
    addFilter: (state, action: PayloadAction<[field: string, value: string]>) => {
      state.filterModel.items.push({
        field: action.payload[0],
        operator: "contains",
        value: action.payload[1],
      });
    },
  },
});

export const { setStart, setEnd, setSortModel, setFilterModel, addFilter } = lambdaControlSlice.actions;

export default lambdaControlSlice.reducer;
